import lobbyWidgetIcon from './games.webp';
import playWithCoinsWidgetIcon from './coins-bank.webp';
import noFavorites from './broken-heart.webp';

export default {
  lobbyWidgetIcon,
  playWithCoinsWidgetIcon,
  noFavorites,
};
